import clsx from 'clsx';
import type { FC } from 'react';

import { authHeaderWrapper } from './share.css';

// yoDEV: Replaced AFFiNE logo and branding with yoDEV for white-label deployment
export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <p style={{ fontSize: '24px', fontWeight: 700 }}>yoDEV</p>
    </div>
  );
};
